import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import {
  ReactRequiredChildren,
  ReactComponentStaticProps,
} from "../../types/react";

import { ComparisonTableColProps } from "./Col";
import { ComparisonTableColHeaderProps } from "./ColHeader";
import { RowProvider } from "./RowContext";
import { useTable } from "./TableContext";
import { useCollapse } from "./CollapseContext";

import styles from "./ComparisonTable.scss";

export type ComparisonTableRowProps = ReactRequiredChildren<
  React.ComponentPropsWithoutRef<"tr">
>;

export const ComparisonTableRow: ((
  props: ComparisonTableRowProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableRowProps> = ({
  children,
  ...restProps
}) => {
  const { hasColumnHeader } = useTable();
  const { collapseRows } = useCollapse();

  let colIndex = 0;

  return (
    <RowProvider>
      <tr
        {...restProps}
        className={cx(styles.row, {
          [styles["collapse-until-l"]]: collapseRows,
        })}
      >
        {React.Children.map(children, (child, index) => {
          const childItem = child as React.ReactElement<
            ComparisonTableColProps | ComparisonTableColHeaderProps
          >;

          if (hasColumnHeader && index === 0) {
            return React.cloneElement(childItem);
          }
          colIndex += 1;
          return React.cloneElement(childItem, { index: colIndex - 1 });
        })}
      </tr>
    </RowProvider>
  );
};

ComparisonTableRow.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

ComparisonTableRow.displayName = "ComparisonTable.Row";

export default ComparisonTableRow;
